
import React, { Fragment } from 'react';
import { GetData, PostData, PutData } from '../../core/controls/helpers/requests';
import BreadCrumb from '../../core/modules/breadcrumbs';
import { getEnvVariable } from '../../modules/environmentalList';
import CFormDropDown from '../../core/modules/form/cformdropdown';
import { getToken } from '../../core/modules/header';
import KendoChart from '../chart/kendochart';
import KendoLine from './kendoline';

const siteTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const permittypeTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const monthsTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const yearTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const monthsJson = [
  {
    "Id": "1",
    "Name": "January"
  },
  {
    "Id": "2",
    "Name": "Feburary"
  },
  {
    "Id": "3",
    "Name": "March"
  },
  {
    "Id": "4",
    "Name": "April"
  },
  {
    "Id": "5",
    "Name": "May"
  },
  {
    "Id": "6",
    "Name": "June"
  },
  {
    "Id": "7",
    "Name": "July"
  },
  {
    "Id": "8",
    "Name": "August"
  },
  {
    "Id": "9",
    "Name": "September"
  },
  {
    "Id": "10",
    "Name": "October"
  },
  {
    "Id": "11",
    "Name": "November"
  },
  {
    "Id": "12",
    "Name": "December"
  }
]
class DashboardChart extends React.Component {

  constructor(props) {
    super(props);
    this.token = getToken()
    this.state = {
      chartApplicationData: [],
      chartPermitData: [],
      site: 0,
      sitesJson: [],
      permitType: 0,
      month: monthsJson[8].Id,
      permitTypeJson: [],
      monthsJson: monthsJson
    }
  }

  componentDidMount() {
    this.loadInitialChart();

  }

  loadInitialApplicationChart = (body) => {
    const url = getEnvVariable('Report') + `/api/ReportQuery/QueryLoad`
    const queryParam = `kendoGrid=N&reportkey=DASHBOARD_SUMMARY_APPLICATIONS_YEAR`;
    //this.setState({ chartApplicationData : [0,0,0,0,0,0,0,0,0,0,0,10] })
    this.fetchData('POST', url, queryParam, body)
      .then(data => {
        let result = [];
        data && data.length > 0 && data.map(res => {
          result.push(res.SatusCount)
        })
        this.setState({
          chartApplicationData: result,
        })
      })
  }

  chartLegendName = (name) => {
    name = name.toLowerCase().replaceAll("_", " ")
    return name.charAt(0).toUpperCase() + name.slice(1);
  }


  monthApplicationChart = (month, monthName) => {
    const body = {
      "SITEVAL": this.state.site,
      "PERMITVAL": this.state.permitType,
      "MONTHVAL": parseInt(month),
      "YEARVAL": this.state.year || new Date().getFullYear()
    }
    const url = getEnvVariable('Report') + `/api/ReportQuery/QueryLoad`
    const queryParam = `kendoGrid=N&reportkey=DASHBOARD_SUMMARY_APPLICATIONS`;
    this.fetchData('POST', url, queryParam, body)
      .then(data => {
        if (Array.isArray(data)) {
          let item = []

          if (data[0]["StatusSettings"]) {
            let chartlabels = data[0]["StatusSettings"]
            let arrchartlabels = chartlabels.split(',')

            if (arrchartlabels.length > 0) {
              arrchartlabels.forEach(element => {
                item.push({
                  "share": data[0][element],
                  "kind": this.chartLegendName(element)
                })
              });
            }
          } else {
            item = [
              {
                "share": data[0]["ADDITIONAL_INFORMATION_REQUIRED"],
                "kind": "Additional Information Required"
              },
              {
                "share": data[0]["APPROVED"],
                "kind": "Approved"
              },
              {
                "share": data[0]["AUTHORIZED"],
                "kind": "Authorized"
              },
              {
                "share": data[0]["COMPLETED"],
                "kind": "Completed"
              },
              {
                "share": data[0]["DENIED"],
                "kind": "Denied"
              },
              {
                "share": data[0]["EXPIRED"],
                "kind": "Expired"
              },
              {
                "share": data[0]["HOLD"],
                "kind": "Hold"
              },
              {
                "share": data[0]["ISSUED"],
                "kind": "Issued"
              },
              {
                "share": data[0]["RECEIVED"],
                "kind": "Received"
              },
              {
                "share": data[0]["REVIEW"],
                "kind": "Review"
              },
              {
                "share": data[0]["WARRANTY"],
                "kind": "Warranty"
              }
            ]
          }


          this.setState({
            chartMonthApplicationData: item,
            monthdisplay: true,
            monthName: monthName
          })
        }
        else {
          let item = [{
            share: "0",
            "kind": "No Data"
          }]
          this.setState({
            chartMonthApplicationData: item,
            monthdisplay: true,
            monthName: monthName
          })
        }
      })
  }



  loadInitialChart = () => {
    const sitedata = this.fetchData('GET', getEnvVariable('Admin') + `/api/sites/all/active`, null, null)
    const permittypedata = this.fetchData('GET', getEnvVariable('AdminConfig') + `/api/SitePermitTypes/All`, null, null)
    Promise.all([sitedata, permittypedata]).then(data => {
      const sites = data[0]
      const permittypes = data[1];
      let initalpermit = permittypes.filter(res => {
        if (sites[0].Id === res.SiteId)
          return res
      })
      const body = {
        "SITEVAL": sites[0].Id,
        "PERMITVAL": permittypes[0].PermitTypeId,
        "YEARVAL": this.state.year || new Date().getFullYear()
      }
      this.loadInitialApplicationChart(body)
      //  this.loadInitialPermitChart(body)
      this.setState({
        sitesJson: data[0],
        site: sites[0].Id,
        permitTypeJson: initalpermit,//data[1],
        permitType: initalpermit[0].PermitTypeId,
        // monthdisplay: false,
        permitsAll: data[1]
      })
    })
  }

  handleSiteDropdownChange = (event) => {
    const { permitsAll } = this.state;
    let initalpermit = permitsAll.filter(res => {
      if (event.target.value === res.SiteId)
        return res
    })
    this.setState({
      site: event.target.value,
      permitTypeJson: initalpermit,
      year: this.state.year,
      monthdisplay: false,
      permitType: (initalpermit && initalpermit.length > 0) ? initalpermit[0].PermitTypeId : '',
    }, () => {
      const body = {
        "SITEVAL": event.target.value,
        "PERMITVAL": this.state.permitType,
        //    "MONTHVAL": this.state.month,
        "YEARVAL": this.state.year,

      }
      this.loadInitialApplicationChart(body)
    })
  }

  handlePermitTypeDropdownChange = (event) => {
    let selectedpermit = this.state.permitTypeJson.filter(e => {
      if (event.target.value === e.Id)
        return e
    })
    this.setState({
      permitValue: event.target.value, monthdisplay: false, permitType: selectedpermit[0].PermitTypeId
    })
    const body = {
      "SITEVAL": this.state.site,
      "PERMITVAL": selectedpermit[0].PermitTypeId,
      "YEARVAL": this.state.year || new Date().getFullYear()
    }
    this.loadInitialApplicationChart(body)
    //  this.loadInitialPermitChart(body)
  }

  handleMonthDropdownChange = (event) => {
    this.setState({
      year: event.target.value
    })
    const body = {
      "SITEVAL": this.state.site,
      "PERMITVAL": this.state.permitType,
      "MONTHVAL": event.target.value,
      "YEARVAL": this.state.year || new Date().getFullYear()
    }

    this.loadInitialApplicationChart(body)
    // this.loadInitialPermitChart(body)
  }

  handleYearDropdownChange = (event) => {
    this.setState({
      year: event.target.value,
      monthdisplay: false
    }, () => {
      const body = {
        "SITEVAL": this.state.site,
        "PERMITVAL": this.state.permitType,
        "YEARVAL": this.state.year
      }

      this.loadInitialApplicationChart(body)
    })

    //  this.loadInitialPermitChart(body)
  }

  fetchData(requestType, url, queryParam, body) {
    const queryStr = queryParam != null ? `${url}?${queryParam}` : `${url}`
    if (requestType == "GET") {
      return GetData(queryStr);
    }
    else if (requestType == "POST") {
      return PostData(queryStr, body, true);
    }
    else if (requestType == "PUT")
      return PutData(queryStr, body, true);
  }

  getYears = () => {
    let currentyear = new Date().getFullYear();
    let yearlist = [];
    while (yearlist.length < 6) {
      yearlist.push({ Id: currentyear + 1, Name: currentyear + 1 });
      currentyear--;
    }
    // this.setState({ year: currentyear })
    return yearlist;
  }

  handlemonthval = (props) => {
    console.log(props);
    monthsJson.map(res => {
      if (res.Name === props) {
        this.monthApplicationChart(res.Id, res.Name);      //  this.loadInitialPermitChart(res.Id)

      }
    })
  }

  render() {
    let yearlist = this.getYears();
    const { monthdisplay } = this.state
    const { options } = this.props;
    const { headerProps } = options
    return (
      <Fragment>
        <div className="col pt-1">
          <BreadCrumb breadcrumbs={headerProps.breadcrumbs} /></div>
        <div className="row col pt-2">
          <div className="col-3">
            <CFormDropDown value={this.state.site || 2} dropdownvalues={this.state.sitesJson} label="County" transformProps={siteTransformProps} handleFieldChange={this.handleSiteDropdownChange} />
          </div>
          <div className="col-3">
            <CFormDropDown value={this.state.permitValue || 5} dropdownvalues={this.state.permitTypeJson} label="Permit Type" transformProps={permittypeTransformProps} handleFieldChange={this.handlePermitTypeDropdownChange} />
          </div>
          <div className="col-2">
            <CFormDropDown value={this.state.year || new Date().getFullYear()} dropdownvalues={yearlist || []} label="Year" transformProps={yearTransformProps} handleFieldChange={this.handleYearDropdownChange} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className={monthdisplay ? "col-sm-6" : "col-sm-12"}>
                <KendoLine data={this.state.chartApplicationData} monthval={this.handlemonthval} />
              </div>
              {monthdisplay && <div className="col-sm-6">
                <KendoChart data={this.state.chartMonthApplicationData} monthName={this.state.monthName} />
              </div>
              }
            </div>

          </div>
        </div>
      </Fragment>

    )
  }
}
//monthdisplay ? "col-sm-6" :
export default DashboardChart
